<template>
  <div class="change-password">
    <v-toolbar style="z-index:5" color="primary" dark app fixed>
      <v-layout :justify-center="true">
        <v-toolbar-title>{{ $t('message.change-password.title') }}</v-toolbar-title>
      </v-layout>
    </v-toolbar>
    <v-content>
      <v-alert class="alert-box ma-0" :value="true" type="info">Just nu befinner du dig utanför appen.</v-alert>
      <v-container class="mt-5">
        <v-flex>
            <v-card class="mt-2">
                <v-card-text>
                    <v-form>
                        <v-text-field prepend-icon="lock" :label="$t('message.change-password.title')" type="password" v-model="password" v-validate="'required|min:4|max:16'" :error-messages="errors.collect('password')" data-vv-name="password" :data-vv-as="$t('message.change-password.title')" ref="password" required></v-text-field>
                        <v-text-field prepend-icon="lock" name="confirm-password" :label="$t('message.general.confirm-password')" type="password" v-model="confirmPassword" v-validate="'required|confirmed:password'" :error-messages="errors.collect('confirm_password')" data-vv-name="confirm_password" :data-vv-as="$t('message.general.confirm-password')" required></v-text-field>
                        <v-alert :value="message.content" :color="message.color" transition="scale-transition">{{message.content}}</v-alert>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="save" :loading="loading" round :dark="!saveCheck && !success" :disabled="saveCheck || success" color="green">{{$t('message.general.save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import { changePassword } from '../store/actions'
export default {
  data: () => ({
    password: null,
    confirmPassword: null,
    message: {
      content: null,
      color: null
    },
    loading: false,
    success: false
  }),
  methods: {
    save () {
      let _this = this
      changePassword(this.$route.query.userId, this.$route.query.code, this.password)
        .then((result) => {
          _this.loading = false
          if (result.status === 200) {
            _this.success = true
            _this.message.content = _this.$t('message.change-password.password-changed')
            _this.message.color = 'success'
          }
          _this.loading = false
        })
        .catch(() => {
          _this.loading = false
          _this.message.color = 'error'
          _this.message = _this.$t('message.api-errors.error-occured-try-again')
        })
    }
  },
  computed: {
    formIsComplete () {
      return this.password && this.confirmPassword
    },
    saveCheck () {
      return this.errors.any() || !this.formIsComplete
    }
  }
}
</script>

<style>

</style>
